export default "__VITE_ASSET__eePrghEs__"